import { APP_PERMISSIONS } from '@report/permission';
import { type Path } from '@report/router';
import { PaperSection, Grid } from '@shared/components';
import { usePermission } from '@shared/permissions';
import { useMemo } from 'react';

import { ReportMenuCard } from '../../components';

const MENU_ITEMS: {
  title: string;
  subtitle: string;
  path: Path;
  requiredPermission: string;
}[] = [
  {
    title: 'รายงานสรุปผลภาพรวมการสอบ',
    subtitle: 'สรุปจำนวนรอบสอบ ผู้สมัคร และผู้เข้าสอบ แยกตามประเภทการสอบและศูนย์สอบ',
    path: '/reports/exam-event-overview',
    requiredPermission: APP_PERMISSIONS.EXAM_EVENT_OVERVIEW_REPORT.VIEW,
  },
  {
    title: 'รายงานวิเคราะห์ผลการสอบตามหลักสูตร',
    subtitle: 'สรุปผลคะแนนและอัตราการผ่านของผู้เข้าสอบในแต่ละหลักสูตร',
    path: '/reports/exam-course-analysis',
    requiredPermission: APP_PERMISSIONS.EXAM_COURSE_ANALYSIS_REPORT.VIEW,
  },
  {
    title: 'รายงานวิเคราะห์คุณภาพข้อสอบ: แบบรายข้อ',
    subtitle: 'ประเมินคุณภาพข้อสอบรายข้อด้วยค่า P และ B-Index',
    path: '/reports/qbank-items-analysis',
    requiredPermission: APP_PERMISSIONS.QBANK_ITEMS_ANALYSIS_REPORT.VIEW,
  },
  {
    title: 'รายงานวิเคราะห์คุณภาพข้อสอบ: แบบรายปี',
    subtitle: 'ประเมินคุณภาพข้อสอบรายข้อด้วยค่า P และ B-Index จากสถิติย้อนหลังรายปี',
    path: '/reports/qbank-items-analysis-yearly',
    requiredPermission: APP_PERMISSIONS.QBANK_ITEMS_ANALYSIS_YEARLY_REPORT.VIEW,
  },
  {
    title: 'รายงานสถานะการใช้งานชุดข้อสอบ',
    subtitle: 'สรุปการใช้งานชุดข้อสอบแต่ละชุด พร้อมจำนวนผู้สอบ อัตราผ่าน และค่าเฉลี่ยคะแนน',
    path: '/reports/qset-usage',
    requiredPermission: APP_PERMISSIONS.QSET_USAGE_STATUS_REPORT.VIEW,
  },
  {
    title: 'รายงานการใช้งานข้อสอบแยกตามชุด',
    subtitle: 'สรุปการใช้งานข้อสอบรายข้อ แยกตามชุดข้อสอบในหลักสูตร',
    path: '/reports/question-usage-by-qset',
    requiredPermission: APP_PERMISSIONS.QUESTION_USAGE_BY_QSET_REPORT.VIEW,
  },
  {
    title: 'รายงานสรุปผลแบบสอบถามหลังการสอบ',
    subtitle: 'สรุปคำตอบแบบสอบถามของผู้เข้าสอบ พร้อมอัตราการผ่านและคะแนนเฉลี่ยในแต่ละคำตอบ',
    path: '/reports/questionnaire',
    requiredPermission: APP_PERMISSIONS.QUESTIONNAIRE_REPORT.VIEW,
  },
];

export default function ReportMenuCardList() {
  const { permissions } = usePermission();

  const menuItems = useMemo(() => {
    return MENU_ITEMS.filter((item) => permissions.includes(item.requiredPermission));
  }, [permissions]);

  const totalItems = menuItems.length;

  return (
    <PaperSection title={`รายงานทั้งหมด (${totalItems})`}>
      <Grid
        sx={(theme) => ({
          gridTemplateColumns: 'repeat(2, 1fr)',
          gap: theme.spacing(4),
          p: theme.spacing(6),
        })}
      >
        {menuItems.map(({ title, subtitle, path }) => (
          <ReportMenuCard key={title} title={title} subtitle={subtitle} href={path} />
        ))}
      </Grid>
    </PaperSection>
  );
}
